import type { ReactNode } from 'react';

export type PillTone = 'ok' | 'warn' | 'bad' | 'ghost' | 'info';
/** Pílula de status (C-14). */
export default function Pill({ tone = 'ghost', children }: { tone?: PillTone; children: ReactNode }) {
  return <span className={`pill ${tone}`}>{children}</span>;
}
